export enum ArcBuilderFieldEnum {
  Profile_EmployeesFT = 1,
  ProfileCustomFields_FieldValue = 2,
}
